import React, { useEffect, useRef, useState } from 'react';
import { BellIcon, SearchIcon } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';
import { useWorkspace } from '../../store/workspaceStore';
import { Avatar } from '../common/Avatar';
export function Topbar({
  title,
  subtitle,
  action
}: {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
}) {
  const notifications = useWorkspace(s => s.notifications);
  const markAllRead = useWorkspace(s => s.markAllNotificationsRead);
  const me = useWorkspace(s => s.personById(s.currentUserId));
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const unread = notifications.filter(n => !n.read).length;
  useEffect(() => {
    const onDoc = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);
  return <header className="flex items-center justify-between gap-4 border-b border-slate-200 bg-white px-6 py-4" data-id="element-44" data-mp="o7sfdq30ce7e">
      <div className="min-w-0" data-id="element-45" data-mp="ja0cy24ql9oy">
        <h1 className="truncate text-xl font-bold tracking-tight text-slate-900" data-id="element-46" data-mp="jb1yx1najglg">{title}</h1>
        {subtitle && <p className="truncate text-sm text-slate-500" data-id="element-47" data-mp="x1x2pzixn7i6">{subtitle}</p>}
      </div>

      <div className="flex items-center gap-3" data-id="element-48" data-mp="s8cayp7xn9rf">
        {action}
        <div className="relative hidden md:block" data-id="element-49" data-mp="16ya13apfa9j9">
          <SearchIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-50" data-mp="170walfvviz44" />
          <input className="w-52 rounded-lg border border-slate-200 bg-slate-50 py-2 pl-9 pr-3 text-sm outline-none placeholder:text-slate-400 focus:border-brand-accent focus:bg-white" placeholder="Search deals…" data-id="element-51" data-mp="1fzhouyubbrz3" />
        </div>

        <div className="relative" ref={ref} data-id="element-52" data-mp="3hrcvv15mj8az">
          <button onClick={() => {
          setOpen(o => !o);
          if (!open) markAllRead();
        }} className="relative rounded-lg border border-slate-200 bg-white p-2 text-slate-600 hover:bg-slate-50" aria-label="Notifications" data-id="element-53" data-mp="3dpiyp2un0mfk">
            <BellIcon className="h-[18px] w-[18px]" data-id="element-54" data-mp="1qn2nmoke8ill" />
            {unread > 0 && <span className="absolute -right-1 -top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-rose-500 px-1 text-[10px] font-bold text-white" data-id="element-55" data-mp="1vlw2olfbwhnv">
                {unread}
              </span>}
          </button>
          {open && <div className="absolute right-0 z-30 mt-2 w-80 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-pop" data-id="element-56" data-mp="24kzjtjuxqmzq">
              <div className="border-b border-slate-100 px-4 py-3 text-sm font-semibold text-slate-800" data-id="element-57" data-mp="2ecdrwg0ycv4h">Notifications</div>
              <div className="mp-scroll max-h-80 overflow-y-auto" data-id="element-58" data-mp="2jc03kl14u3b6">
                {notifications.length === 0 && <p className="px-4 py-6 text-center text-sm text-slate-400" data-id="element-59" data-mp="2ncjzxmdvt2w9">All caught up.</p>}
                {notifications.map(n => <div key={n.id} className="border-b border-slate-50 px-4 py-3 last:border-0" data-id="element-60" data-mp="br1fca6y0972">
                    <p className="text-sm text-slate-700" data-id="element-61" data-mp="7mjzgm3peg1k">{n.text}</p>
                    <p className="mt-1 text-xs text-slate-400" data-id="element-62" data-mp="2o8q0chbm7jv">{formatDistanceToNow(new Date(n.createdAt), {
                  addSuffix: true
                })}</p>
                  </div>)}
              </div>
            </div>}
        </div>

        <div className="flex items-center gap-2 rounded-lg border border-slate-200 py-1 pl-1 pr-3" data-id="element-63" data-mp="vcwbo95zeyxy">
          <Avatar person={me} size={28} data-id="element-64" data-mp="qfebp89xzu23" />
          <span className="hidden text-sm font-medium text-slate-700 sm:block" data-id="element-65" data-mp="lnmiepzeja89">{me?.name}</span>
        </div>
      </div>
    </header>;
}